'use client';

import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary';
import { ErrorCode, getErrorMessage, parseErrorObject, reportError } from '@/utils/errors';
import ErrorFallback from './error-fallback';

export default function ErrorBoundary({ children }: { children: React.ReactNode }) {
  return (
    <ReactErrorBoundary
      onError={(error, info) => {
        reportError(error, info);
      }}
      fallbackRender={({ error, resetErrorBoundary }) => {
        const errorObject = parseErrorObject(error);
        const errorMessage = getErrorMessage(errorObject.code as ErrorCode);

        return (
          <div className='w-full min-h-[60vh] flex items-center justify-center px-5'>
            <ErrorFallback
              errorCode={errorObject.code as ErrorCode}
              errorMessage={errorMessage}
              onRetry={() => window.location.reload()}
            />
          </div>
        );
      }}
    >
      {children}
    </ReactErrorBoundary>
  );
}
